import React from 'react';
import { Cards } from '../Card/Card';

const JobsOverview = ({jobSummary}) => (
    <Cards cards={jobSummary}/>
);

export default JobsOverview;
